import { AbstractGridListingFilter, type IGridListingFilterValue } from 'components/page/listing-grid-v1/grid.listing.filter';

// scopeVariable.value values = 'active' | 'inactive' | ''
// active filter values sent = true | false or not sent

export class ActiveInactiveStatusGridListingFilter extends AbstractGridListingFilter {
    constructor(
        _name: string,
        scopeVariable: any,
        private i18nActive: string,
        private i18nInactive: string
    ) {
        super(_name, scopeVariable);
    }

    public values() {
        return [
            {
                name: 'active',
                value: this.value()
            }
        ];
    }

    fieldName(variable) {
        return variable.name;
    }

    value() {
        return this.scopeVariable.value === 'active' ? true : false;
    }

    title(value) {
        let title = '';
        if (value === 'active') {
            title = '<span i18n="' + this.i18nActive + '"></span>';
        } else if (value === 'inactive') {
            title = '<span i18n="' + this.i18nInactive + '"></span>';
        }
        return title;
    }

    public descriptions() {
        return (_values: IGridListingFilterValue[]) => {
            const title = this.title(this.scopeVariable.value);
            if (title) {
                return {
                    quick: this.quick,
                    empty: this.noBottom,
                    titles: [title]
                };
            }
            return null;
        };
    }

    public isEmpty() {
        return this.scopeVariable.value == '';
    }

    public clear() {
        this.scopeVariable.value = '';
    }
}
